import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IMetierCompetence from '../../models/IMetierCompetence';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface ICompetencesMetierProps {
  isModeSelection?: boolean;
}

class MetierCompetence extends IBaseModel implements IMetierCompetence {
  idMetierCompetence: Guid = Guid.empty;
}

export default function CompetencesMetier({ isModeSelection }: ICompetencesMetierProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="MetierCompetence" model={MetierCompetence} descriptionOptions={{ maxLength: 50, width: 200 }} />
  );
}